import moment from 'moment';
import { Alcohols } from './../constants/Alcohols';
import { AlcoholCount } from './../types/AlcoholCount';
export const getAlcoholGrams = (amountMl: number, alcPercentage: number) => {
    return (amountMl * alcPercentage * 0.8) / 100;
};

export const alcoholsToAlcoholGrams = (alcohols: AlcoholCount[]) => {
    return alcohols.reduce((acc, alc) => {
        const alcoholInfo = Alcohols[alc.type];
        return acc + getAlcoholGrams(alcoholInfo.ml, alcoholInfo.alcPercentage) * alc.count;
    }, 0);
};

export const getOneMinuteGramsDifference = (weight: number) => {
    return (weight * 0.135) / 60;
};

export const getActualAlcoholGrams = (weight: number, drinkingStart: moment.Moment, totalGrams: number) => {
    let consumationTimeMinutes = 0;

    if (moment().isAfter(drinkingStart)) {
        consumationTimeMinutes = moment().diff(drinkingStart, 'minute');
    }

    const actualGrams = totalGrams - consumationTimeMinutes * getOneMinuteGramsDifference(weight);
    if (actualGrams < 0) {
        return 0;
    }
    return actualGrams;
};
